import { RESOURCE_CATEGORIES } from '../constants/somalilandResources';
import { translations } from '../i18n';
import { useLanguage } from '../LanguageContext';

function getLabel(lang, key) {
  const parts = key.split('.');
  let cur = translations[lang];
  for (const part of parts) {
    if (cur == null || typeof cur !== 'object') return key;
    cur = cur[part];
  }
  return typeof cur === 'string' ? cur : key;
}

function ResourceCardContent({ category, lang }) {
  if (category.groups) {
    return (
      <div className="resource-card__groups">
        {category.groups.map((group) => (
          <div key={group.id} className="resource-card__group">
            <h4 className="resource-card__group-title">
              {getLabel(lang, `resources.fishGroups.${group.id}`)}
            </h4>
            <ul className="resource-card__list">
              {group.items.map((itemId) => (
                <li key={itemId}>{getLabel(lang, `resources.items.${itemId}`)}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    );
  }

  return (
    <ul className="resource-card__list">
      {category.items.map((itemId) => (
        <li key={itemId}>{getLabel(lang, `resources.items.${itemId}`)}</li>
      ))}
    </ul>
  );
}

function ResourceCard({ category, lang }) {
  const { icon: Icon, id } = category;

  return (
    <article className="resource-card">
      <div className="resource-card__head">
        <span className="resource-card__icon-wrap" aria-hidden="true">
          <Icon size={24} strokeWidth={1.75} />
        </span>
        <h3 className="resource-card__title">
          {getLabel(lang, `resources.categories.${id}`)}
        </h3>
      </div>
      <ResourceCardContent category={category} lang={lang} />
    </article>
  );
}

export default function SomalilandResourcesSection() {
  const { lang, t } = useLanguage();

  return (
    <section
      className="section section--resources"
      id="resources"
      aria-labelledby="resources-heading"
    >
      <div className="section__head">
        <h2 id="resources-heading">{t('resources.title')}</h2>
        <p className="section__sub">{t('resources.sub')}</p>
      </div>

      <ul className="resource-grid">
        {RESOURCE_CATEGORIES.map((category) => (
          <li key={category.id}>
            <ResourceCard category={category} lang={lang} />
          </li>
        ))}
      </ul>
    </section>
  );
}
